module.exports = __webpack_public_path__ + "static/media/T12-01.25d25085.svg";